import { useHistory, useParams } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core';
import styles from '../SignIn/styles';
import {
    getMembrosByGrupo,
    getGrupos,
    atualizarMembro,
    deletarCrianca,
    getCriancasPalavraFest,
} from '../../services/GruposApi';
import MembrosTable from '../../components/Grupo/MembrosTable';
import CriancasTable from '../../components/Grupo/CriancasTable';
import { logout } from '../../services/AuthApi';
import { getIdMembro } from '../../services/api';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function Grupos(props) {
    const { classes } = props;
    const [grupoSelecionado, setGrupoSelecionado] = useState(false);
    const [grupos, setGrupos] = useState([]);
    const [membros, setMembros] = useState([]);
    const [dadosGrupo, setDadosGrupo] = useState({});
    const [isCarregandoGrupo, setCarregandoGrupo] = useState(true);
    const [error, setError] = useState('');
    const history = useHistory();
    const { indexGrupo } = useParams();

    async function fetchGrupos() {
        try {
            let grps = await (await getGrupos()).data;
            let idMembroLider;

            if (grps.length === 0) {
                grps = [];
                idMembroLider = getIdMembro();
            } else {
                idMembroLider = grps[0].idMembroLider1;
            }

            /* grps.push({
                idGrupoPequeno: idMembroLider,
                isCriancaPalavraFest: true,
            }); */

            setGrupos(grps);
            setCarregandoGrupo(false);
        } catch (err) {
            setError(err);
        }
    }

    async function removerMembro(membro) {
        try {
            const membroTemp = {
                idMembro: membro.idMembro,
                idGrupoPequeno: null,
            };
            await atualizarMembro(membroTemp.idMembro, membroTemp);
            setMembros(
                membros.filter(item => item.idMembro !== membro.idMembro)
            );
        } catch (err) {
            return false;
        }

        return true;
    }

    async function removerCrianca(membro) {
        try {
            await deletarCrianca(membro.id);
            setMembros(membros.filter(item => item.id !== membro.id));
        } catch (err) {
            return false;
        }

        return true;
    }

    async function fetchMembros(idGrupoPequeno) {
        try {
            const response = await (await getMembrosByGrupo(idGrupoPequeno))
                .data;
            const t = Date.now();
            return response.map(m => ({
                ...m,
                txFotoUrl: m.txFotoUrl ? `${m.txFotoUrl}?t=${t}` : m.txFotoUrl,
            }));
        } catch (err) {
            return null;
        }
    }

    async function fetchCriancas(idMembro) {
        try {
            const response = await (await getCriancasPalavraFest(idMembro))
                .data;
            return response;
        } catch (err) {
            return null;
        }
    }

    async function carregarTab(grpSelecionado) {
        setGrupoSelecionado(grpSelecionado);
        setDadosGrupo({
            tipo: grpSelecionado.nbTipo,
            pastor: grpSelecionado.txPastor
                ? `Pastor: ${grpSelecionado.txPastor}`
                : '(PASTOR AUSENTE)',
            coordenador: grpSelecionado.txCoordenador
                ? `Coordenador: ${grpSelecionado.txCoordenador}`
                : '(COORDENADOR AUSENTE)',
            endereco: grpSelecionado.txEndereco
                ? grpSelecionado.txEndereco
                : '(ENDEREÇO AUSENTE)',
            numero: grpSelecionado.txNumero ? grpSelecionado.txNumero : 'S/N',
            bairro: grpSelecionado.txBairro
                ? grpSelecionado.txBairro
                : '(BAIRRO AUSENTE)',
            dia: grpSelecionado.txDiaSemanaReuniao
                ? grpSelecionado.txDiaSemanaReuniao
                : '(DIA AUSENTE)',
            horario: grpSelecionado.txHorarioReuniao
                ? grpSelecionado.txHorarioReuniao
                : '(HORÁRIO AUSENTE)',
            latitude: grpSelecionado.nbLatitude
                ? `LAT ${grpSelecionado.nbLatitude}`
                : '(LATITUDE AUSENTE)',
            longitude: grpSelecionado.nbLongitude
                ? `LONG ${grpSelecionado.nbLongitude}`
                : '(LONGITUDE AUSENTE)',
        });

        let membrosRemoto = [];

        if (grpSelecionado && !grpSelecionado.isCriancaPalavraFest) {
            membrosRemoto = await fetchMembros(grpSelecionado.idGrupoPequeno);
        } else {
            membrosRemoto = await fetchCriancas(grpSelecionado.idGrupoPequeno);
        }

        setMembros(membrosRemoto);
    }

    useEffect(() => {

        if (!error) {
            if (isCarregandoGrupo) {
                fetchGrupos();
            } else if (
                !indexGrupo ||
                isNaN(indexGrupo) ||
                indexGrupo > grupos.length - 1
            ) {
                history.push('/grupos/0');
                carregarTab(grupos[0]);

            } else {
                carregarTab(grupos[indexGrupo]);
            }
        }

    }, [isCarregandoGrupo, error]);

    const handleChange = (event, grpSelecionado) => {
        const idxGrupo = grupos.findIndex(
            g => g.idGrupoPequeno === grpSelecionado.idGrupoPequeno
        );
        if (idxGrupo !== -1) {
            history.push(`/grupos/${idxGrupo}`);
        }
        setMembros([]);
        carregarTab(grpSelecionado);
    };

    const handleRemoveMembro = async (event, membro) => {
        removerMembro(membro);
    };

    const handleRemoveCrianca = async (event, membro) => {
        removerCrianca(membro);
    };

    return !isCarregandoGrupo ? (
        <div className={classes.tab}>
            <AppBar position="static" style={{ zIndex: 1000 }}>
                <Tabs value={grupoSelecionado} onChange={handleChange}>
                    {grupos.map((grupo, i) => (
                        <Tab
                            key={grupo.idGrupoPequeno}
                            value={grupo}
                            label={
                                grupos.length > 1 ? `GA DE ${grupo.txDiaSemanaReuniao}` : 'MEU GA'
                                // !grupo.isCriancaPalavraFest
                                //     ? (grupos.length > 1 ? `Grupo ${i + 1}` : 'MEU GA')
                                //     : 'Infantil/Kids'
                            }
                            {...a11yProps(1)}
                        />
                    ))}
                </Tabs>
            </AppBar>
            <TabPanel value={grupoSelecionado} index={grupoSelecionado}>
                {!grupoSelecionado.isCriancaPalavraFest ? (
                    <MembrosTable
                        dadosGrupo={dadosGrupo}
                        membros={membros}
                        handleRemoverItem={handleRemoveMembro}
                        idIgreja={grupoSelecionado.idIgreja}
                        idGrupoPequeno={grupoSelecionado.idGrupoPequeno}
                    />
                ) : (
                    <CriancasTable
                        criancas={membros}
                        handleRemoverItem={handleRemoveCrianca}
                        idMembro={grupoSelecionado.idGrupoPequeno}
                    />
                )}
            </TabPanel>
        </div>
    ) : (
        <div>Carregando...</div>
    );
}

export default withStyles(styles)(Grupos);
